import { Component, effect, inject, signal } from '@angular/core';
import { AnalyticsService, WidgetData } from '../../../../../core/services/analytics.service';
import { BaseComponent } from '../../../../../core/shared/common/base.component';
import { filter, switchMap } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { MetricCardComponent } from '../../../../../core/components/metric-card';
import { CommonModule } from '@angular/common';
import { getPastDaysDateRange } from '../../../../../core/shared/common/date-range.util';

@Component({
  selector: 'app-tpr-widget',
  standalone: true,
  imports: [MetricCardComponent, CommonModule],
  templateUrl: './tpr-widget.component.html',
  styleUrl: './tpr-widget.component.scss',
  providers: [AnalyticsService],
})
export class TprWidgetComponent extends BaseComponent {
  private route = inject(ActivatedRoute);
  private analyticsService = inject(AnalyticsService);

  public tprData = signal<WidgetData>({ value: 0, colors: [] });
  public isLoading = signal<boolean>(true);

  // For the metric card
  public cardTitle = 'True Positive Rate';

  constructor() {
    super();
    this.initEffect();
  }

  private initEffect() {
    effect(() => {
      this.route.queryParams
        .pipe(
          filter((params) => {
            return !!params['organizationId'];
          }),
          switchMap((params) => {
            // Rolling 30-day window for statistical stability
            const dateRange = getPastDaysDateRange(30);
            return this.analyticsService.getTpr(params['organizationId'], dateRange);
          }),
        )
        .subscribe({
          next: (data) => {
            this.tprData.set(data);
            this.isLoading.set(false);
          },
          error: (error) => {
            console.error(error);
            this.isLoading.set(false);
          },
        });
    });
  }
}
